module.exports = __webpack_public_path__ + "static/media/60.57bf497a.png";